import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { Router } from "@angular/router";
import "rxjs/Rx";

import { Observable, Subscription } from 'rxjs/Rx';
import { AuthService } from "../../_services/userservice/auth.service";
import { overlayConfigFactory } from "angular2-modal";
import { Modal, BSModalContext } from "angular2-modal/plugins/bootstrap";
import { ForgetPasswordComponent } from "../forget-password/forget-password.component";
import { LoyaltyLoginComponent } from "../loyalty-login/loyalty-login.component-Step1";
import { VerifyMobileComponent } from "../user-register/RegistrationPopup/verify-mobile/verify-mobile.component";
import {
    AppSettings,
    enumStatusCodeList
} from "../../sharedcomponents/_common/constants/app.constants";
import { UserLanguageService } from "../../sharedcomponents/commonservice/commonlangservice.service";
import { utilityService } from "../../sharedcomponents/commonservice/utility.service";
import { usercommonattribute } from "../../_services/userservice/user.common.service";
import { geolocation } from "../../sharedcomponents/commonservice/geolocation/geoloc";
import { AlertService } from "../../sharedcomponents/commonservice/alert.service";
import { VerifyDeviceComponent } from "../verify-device/verify-device.component";
import { TranslateService } from "ng2-translate/ng2-translate";
import { AlertPopupComponent } from "../../sharedcomponents/_directive/alert-popup/alert-popup.component";
import { ErrorPopupComponent } from "../../sharedcomponents/_directive/error-popup/error-popup.component";
import {
    UserProfileTMNIovation,
    enumEventype
} from "../../models/user/user.tm.profile.model";
import { Ng2DeviceService } from "ng2-device-detector";
import { UserGioLocation } from "../../models/user/usergioLocation";
import { GoogleAnalyticsEventsService } from "../../sharedcomponents/commonservice/googleAnalytics/google-analytics-events-service.service";
import { countrylist } from "../../sharedcomponents/_common/countrylist/countrylist.component";
import { environment } from "environments/environment";
import { VersionCheckService } from "../../_services/version-check.service";
import { loyaltylogin } from "app/_services/userservice/user.loyaltylogin.service";
import { ThreatMetrixService } from "../../_services/ThreatMetrix/threatmetrix"
import { PayagainFailedorderService } from "app/_services/transaction/payagain-failedorder.service";

declare var sysSettings: any;
declare var ___MobileAgent___: any;

@Component({
    moduleId: module.id,
    selector: "app-login",
    templateUrl: "./login.component.html",
    providers: [
        AuthService,
        Modal,
        ForgetPasswordComponent,
        AppSettings,
        LoyaltyLoginComponent,
        UserLanguageService,
        VersionCheckService,
        utilityService,
        ThreatMetrixService
    ],
    styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
    model: any = {};
    result: any;
    x2js: any;
    userProfileTMNIovation: UserProfileTMNIovation;
    // languageList;
    appSettings;
    syssettings;
    loading: boolean = false;
    // @HostListener('window:beforeunload', ['$event'])
    // doSomething($event) {

    //  // if(this.hasChanges) $event.returnValue='Your data will be lost!';
    //  alert('Page Refersh');
    // }
    userGioLocation: UserGioLocation;
    fraudBusy: Subscription;

    constructor(
        private router: Router,
        private alertService: AlertService,
        private auth: AuthService,
        private translate: TranslateService,
        public modal: Modal,
        public utilserv: utilityService,
        private userCommon: usercommonattribute,
        public geoloc: geolocation,
        private deviceService: Ng2DeviceService,
        public googleAnalyticsEventsService: GoogleAnalyticsEventsService,
        private versionCheckService: VersionCheckService,
        private loyallog: loyaltylogin,
        public vcref: ViewContainerRef,
        private threatMetrixService: ThreatMetrixService
    ) {
        this.userGioLocation = new UserGioLocation();
        this.model.DeviceToken = "";
        this.model.otpNumber = "";
        this.syssettings = sysSettings;
        this.model.username = "";
        this.model.password = "";
    }
    // Will Call from UI(View), For language Change
    changeLanguage(lang) {
        if (sessionStorage.langCode == undefined || sessionStorage.langCode == "") {
            sessionStorage.langCode = lang;
        } else if (sessionStorage.langCode.toLowerCase() == "en") {
            sessionStorage.langCode = "es";
        } else if (sessionStorage.langCode.toLowerCase() == "es") {
            sessionStorage.langCode = "en";
        }
        // sessionStorage.langCode = lang;
        this.translate.use(sessionStorage.langCode);
    }
    ngOnInit() {
        // check new web build version and page reload
        this.getWebSession();
        this.threatMetrixService.Init();
        // this.versionCheckService.initVersionCheck(environment.versionCheckURL);
        try {
            let domain = window.location.origin;
            let versionCheckURL = domain + "/assets/version.json";
            this.versionCheckService.initVersionCheck(versionCheckURL);
        } catch (error) { }

        /* Fetch RSA Publickey & KeyUID. from server*/
        this.appSettings = AppSettings;
        let _self = this;

        if (
            this.utilserv.getObjectText(localStorage.sessionId) == "" ||
            // this.utilserv.getObjectText(sessionStorage.iovationBBKey) == '' ||
            localStorage.CountryCollection == undefined ||
            localStorage.BeneficiaryRelations == undefined ||
            localStorage.TransferReasons == undefined
            // localStorage.countryDetailsCollection == undefined// remove from system, no longer use
        ) {
            _self.router.navigate(["/splashscreen"]);
        }
        let geoSub = this.geoloc.getGioLocation().subscribe(data => {
            this.userGioLocation = data;

            if (geoSub) {
                geoSub.unsubscribe();
            }

            // this.geoloc.setserGioLocation(this.userGioLocation);
            // this.utilserv.busy = this.utilserv
            //     .getBackGroundImage(this.getBackGroundImageEnvelope())
            //     .subscribe(data => {
            //         this.utilserv.setBackGroundImage(data);
            //     });
            // if (this.utilserv.getObjectText(localStorage.sessionId) == '') {
            //   localStorage.sessionId = this.generateRandomString(20);
            // }
        });

        this.userProfileTMNIovation = new UserProfileTMNIovation();
        this.userProfileTMNIovation.deviceProfile.IovationBlackBoxKey = sessionStorage.iovationBBKey;
        this.userProfileTMNIovation.eventType = enumEventype[enumEventype.Login];

        if (this.isWebView()) {
            AppSettings.Platform = "Mobile";
            ___MobileAgent___.ShowWrapper("1");
        }
    }

    isWebView(): boolean {
        return ___MobileAgent___.IsWrapper();
    }

    private getWebSession() {

        if (this.utilserv.isNull(sessionStorage.KeyUID) == "") {

            let _self = this;

            return new Promise<void>((resolve, reject) => {

                _self.fraudBusy = _self.auth.getWebSession().subscribe(data => {

                    if (data.Envelope.Body.FraudDetectionResponse.StatusCode == 10000) {

                        sessionStorage.publicKeyRSA = data.Envelope.Body.FraudDetectionResponse.RSAPublicKey;
                        sessionStorage.KeyUID = data.Envelope.Body.FraudDetectionResponse.KeyUID;
                        _self.userCommon.KeyUID = data.Envelope.Body.FraudDetectionResponse.KeyUID;

                        resolve();

                    } else {

                        _self.openErrorAlert(
                            _self.translate.instant("Common_lblOops"),
                            _self.translate.instant("Message_errorMessage")
                        );

                        reject();

                    }
                });
            });
        } else {
            return Promise.resolve();
        }
    }

    login() {

        let _self = this;

        this.getWebSession().then(() => {

            _self.loading = true;
            this.modal.overlay.defaultViewContainer = this.vcref;
            if (sessionStorage.publicKeyRSA === undefined) {

                const modalData: any = {};
                modalData.Title = this.translate.instant("Common_lblOops").toString();
                modalData.Message = this.translate.instant("Message_errorMessage");
                modalData.Action = this.translate.instant("Common_lblOk").toString();
                _self.modal
                    .open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext))
                    .then(function (obj) {
                        obj.onDestroy.subscribe(error => {
                            window.location.reload();
                        });
                    });
                return false;
            }

            let geoSub = _self.geoloc.getserGioLocation().subscribe(data => {

                _self.userGioLocation = data;

                if (geoSub) {
                    geoSub.unsubscribe();
                }

            });

            if (_self.userGioLocation.latitude == undefined || _self.userGioLocation.longitude == undefined) {

                _self.utilserv.busy = _self.translate
                    .use(sessionStorage.langCode)
                    .subscribe(data => {
                        const modalData: any = {};
                        modalData.Action = _self.translate.instant("Common_lblOk");
                        modalData.Title = _self.translate.instant("Common_lblInfo").toString();
                        modalData.Message = _self.translate
                            .instant("Login_permLocDeny")
                            .toString();
                        _self.modal.open(
                            AlertPopupComponent,
                            overlayConfigFactory({ modalData }, BSModalContext)
                        );
                    });

                return false;
            }

            let deviceInfo = _self.deviceService.getDeviceInfo();

            _self.utilserv.busy = _self.auth
                .login(_self.model, deviceInfo, _self.userGioLocation)
                .subscribe(data => {
                    _self.loading = false;
                    let resJSON = data;

                    _self.model.otpNumber = "";
                    _self.model.DeviceToken = "";

                    if (resJSON.Envelope.Body.LoginResponse.StatusCode == enumStatusCodeList.AESkeyNotFound || resJSON.Envelope.Body.LoginResponse.StatusCode == 0) {

                        sessionStorage.KeyUID = "";
                        _self.router.navigate(["/splashscreen"]);
                        return;

                    } else if (resJSON.Envelope.Body.LoginResponse.StatusCode == 8016) {

                        _self.alertService.openErrorAlert(_self.translate.instant("Common_lblInfo"), this.translate.instant("Common_InvalidPhoneNumber"));

                    } else {

                        if (resJSON.Envelope.Body.LoginResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                            // Log User Login Succesfull
                            //bharat
                            // this.googleAnalyticsEventsService.emitEvent('User', 'Login-ICE', 'country: USA, color: red', 100);

                            sessionStorage.T2 = _self.utilserv.getObjectText(resJSON.Envelope.Body.LoginResponse.SessionObject.T2);
                            _self.userDetails();
                        } else if (resJSON.Envelope.Body.LoginResponse.StatusCode == enumStatusCodeList.EmailNotVerified) {
                            const modalData: any = {};
                            modalData.Title = _self.translate.instant("Common_lblInfo").toString();
                            modalData.Message = _self.translate.instant("EmailConfirmPopup_desc");
                            modalData.Action = _self.translate.instant("Common_lblOk").toString();
                            this.model.DeviceToken = _self.utilserv.getObjectText(data.Envelope.Body.LoginResponse.DeviceToken);
                            _self.modal.open(
                                AlertPopupComponent,
                                overlayConfigFactory({ modalData }, BSModalContext)
                            );
                            // this.openErrorAlert(this.translate.instant('Common_lblOops'), this.translate.instant('infoEmailAccountActivationLinkPopupText_InfoPopup'));
                        } else if (resJSON.Envelope.Body.LoginResponse.StatusCode == enumStatusCodeList.VerifyDevice) {
                            const modalData: any = {};
                            modalData.Title = _self.translate
                                .instant("Common_lblConfirmation")
                                .toString();
                            modalData.Message = _self.translate.instant(
                                "MultiDeviceLoginPopup_desc"
                            );
                            modalData.watermark = _self.translate.instant("OTPConfirmPopup_inputOTP");
                            _self.model.DeviceToken = _self.utilserv.getObjectText(
                                data.Envelope.Body.LoginResponse.DeviceToken
                            );
                            _self.modal.open(
                                VerifyDeviceComponent,
                                overlayConfigFactory({ modalData }, BSModalContext)
                            )
                                .then(function (obj) {
                                    obj.onDestroy.subscribe(error => {
                                        console.log("Observer got a next value: " + error);
                                        if (modalData.next == "yes") {
                                            _self.model.otpNumber = modalData.otpNumber;
                                            _self.login();
                                            // _self.model.otpNumber = "";
                                            // _self.model.DeviceToken = "";
                                        } else {
                                            _self.model.otpNumber = "";
                                            _self.model.DeviceToken = "";
                                            _self.router.navigate(["/login"]);
                                        }
                                    });
                                });
                        } else if (resJSON.Envelope.Body.LoginResponse.StatusCode == enumStatusCodeList.EmailAndPhoneNotVerified || resJSON.Envelope.Body.LoginResponse.StatusCode == enumStatusCodeList.PhoneNotVerified) {
                            _self.model.UserID = _self.utilserv.getObjectText(
                                resJSON.Envelope.Body.LoginResponse.UserID
                            );
                            _self.model.MobileNumber = _self.utilserv.getObjectText(
                                resJSON.Envelope.Body.LoginResponse.MobileNumber
                            );

                            _self.verifyMobilePopup(_self.model);
                        } else if (resJSON.Envelope.Body.LoginResponse.StatusCode == "-10000") {
                            _self.openErrorAlert(
                                _self.translate.instant("Common_lblOops"),
                                _self.translate.instant("Message_errorMessage")
                            );
                        } else {
                            _self.openErrorAlert(
                                _self.translate.instant("Common_lblOops"),
                                resJSON.Envelope.Body.LoginResponse.StatusMessage
                            );
                        }
                    }
                });
        });
    }

    userDetails() {

        let _self = this;

        this.utilserv.busy = this.auth.getUserDetail().subscribe(data => {
            const resJSON = data;
            try {
                if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                    sessionStorage.UserData = this.utilserv.AESEncrypt(
                        JSON.stringify(resJSON)
                    );
                    // Check user prefered country available or not
                    const perfCountryCollection = JSON.parse(
                        localStorage.CountryCollection
                    );
                    const isPrefCountryExist = perfCountryCollection.filter(
                        preCounttry =>
                            preCounttry.CountryCode ==
                            resJSON.Envelope.Body.CustomerInfoResponse.PreferCountryCode
                    );

                    if (isPrefCountryExist.length <= 0) {
                        // Open Country List
                        this.openCountryBox();
                    } else {
                        const userDetails = this.auth.setUserDetails(resJSON);
                        this.sendDeviceDetails(userDetails);
                        this.threatMetrixService.Profile().then(sessionId => {

                            _self.userProfileTMNIovation.deviceProfile.SessionID = sessionId;
                            _self.userProfileTMNIovation.userProfile.email = _self.model.username;

                            var saveLoginProfiling = _self.auth.profileTMnIovation(_self.userProfileTMNIovation).subscribe(data => {
                                if (saveLoginProfiling != undefined) {
                                    saveLoginProfiling.unsubscribe();
                                }
                            });
                        });

                        this.router.navigate(["/dashboard"])/*.then(() => {

                            _self.utilserv.getRequirements(new Observable<void>(() => {})).subscribe(data => {

                                if (data.providerDetails.Onfido) {
                                    ___MobileAgent___.Onfido.Start(data.providerDetails["Onfido"], function(data) {
                                    
                                        var _post = _self.utilserv.postRequirements(data, new Observable<void>(() => {})).subscribe(() => {
        
                                            if (typeof _post !== undefined) {
                                                _post.unsubscribe();
                                            }
                                        });
                                    });    
                                }
                            });    
                        })*/;

                        return;

                    }
                } else {
                    this.openErrorAlert(
                        this.translate.instant("Common_lblOops"),
                        this.translate.instant("Message_errorMessage")
                    );
                    console.log(
                        resJSON.Envelope.Body.CustomerInfoResponse.StatusCode +
                        " - " +
                        resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage
                    );
                }
            } catch (ex) {
                console.log(ex);
            }
        });
    }

    sendDeviceDetails(userDetails: usercommonattribute) {
        let deviceInfo = this.deviceService.getDeviceInfo();
        this.auth
            .sendDeviceDetails(userDetails, deviceInfo, this.userGioLocation)
            .subscribe(data => { });
    }

    openForget() {
        return this.modal.open(
            ForgetPasswordComponent,
            overlayConfigFactory({ num1: 2, num2: 3 }, BSModalContext)
        );
    }

    openLoyaltyCardLogin() {
        const modalData: any = {};
        modalData.isLoggedIn = false;
        this.modal.open(
            LoyaltyLoginComponent,
            overlayConfigFactory({ modalData }, BSModalContext)
        );
    }

    verifyMobilePopup(user: any) {
        const self = this;
        let modalData: any = {};
        modalData.user = user;
        this.modal
            .open(
                VerifyMobileComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe(error => {
                    console.log("Observer got a next value: " + error);
                    if (modalData.next == "yes") {
                        self.login();
                        self.model.otpNumber = "";
                        self.model.DeviceToken = "";
                    }
                });
            });
    }
    callCustomerCare() {
        const CountryObject: any = this.geoloc.getCountryObject();
        if (
            CountryObject.CustomerCareNumber &&
            CountryObject.CustomerCareNumber != undefined
        ) {
            if (this.isWebView()) {

                ___MobileAgent___.OpenExternalLink("tel:" + CountryObject.CustomerCareNumber);

            } else {

                this.openErrorAlert(
                    this.translate.instant("Common_lblInfo"),
                    this.translate.instant("Message_lblCustomerCareContactPrefix") +
                    " " +
                    CountryObject.CustomerCareNumber +
                    " " +
                    this.translate.instant("Message_lblCustomerCareContactSuffix")
                );

            }
        } else {
            this.openErrorAlert(
                this.translate.instant("Common_lblInfo"),
                this.translate.instant("Message_customerCareError")
            );
        }
    }
    openTutorial() {
        ___MobileAgent___.OpenExternalLink(sessionStorage.tuorialLink);
    }
    generateRandomString(length) {
        let text = "";
        const possible =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let i = 0; i < length; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }
    openCountryBox() {
        this.modal.overlay.defaultViewContainer = this.vcref;
        const self = this;
        const modalData: any = {};
        modalData.Title = this.translate.instant("PrefCountry").toString();
        modalData.Message = this.translate
            .instant("lblPreferredCountryMessage")
            .toString(); //'Please select your Country of preference from the list below:';
        return this.modal
            .open(countrylist, overlayConfigFactory({ modalData }, BSModalContext))
            .then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    console.log("Observer got a next value: " + data);
                    if (modalData.next.CountryCode == undefined) {
                        self.router.navigate(["/login"]);
                    } else {
                        // Call Service and Store Preffered country
                        self.utilserv.busy = self.auth
                            .setUserPrefCountry(modalData.next.CountryCode)
                            .subscribe(userData => {
                                const resJSON = userData;
                                const userDetails = self.auth.setUserDetails(resJSON);
                                self.sendDeviceDetails(userDetails);
                                if (
                                    userData.Envelope.Body.CustomerInfoResponse.StatusCode ==
                                    enumStatusCodeList.SUCCESS
                                ) {
                                    self.router.navigate(["/dashboard"]);
                                }
                            });
                    }
                });
            });
    }
    openErrorAlert(title, msg) {
        const modalData: any = {};
        modalData.Title = title;
        modalData.Message = msg;
        // this.modal.overlay.defaultViewContainer = this.vcRef;
        this.modal.open(
            ErrorPopupComponent,
            overlayConfigFactory({ modalData }, BSModalContext)
        );
    }

    openDeviceApp(deviceRef) {
        let deviceInfo = this.deviceService.getDeviceInfo();
        let url = "";
        // alert('deviceInfo' + JSON.stringify(deviceInfo));
        // alert('isTablet' + this.deviceService.isTablet());
        // alert('isMobile' + this.deviceService.isMobile());
        let device = deviceInfo.device.toLowerCase();
        console.log(device);
        if (device == "unknown") {
            if (deviceRef == "android") {
                url = AppSettings.androidPhone;
            }
            if (deviceRef == "iphone") {
                url = AppSettings.iPhonePhone;
            }
        }
        if (deviceRef == "android") {
            if (this.deviceService.isMobile()) {
                url = AppSettings.androidPhone;
            }
            if (this.deviceService.isTablet()) {
                url = AppSettings.androidTab;
            }
        }
        if (deviceRef == "iphone") {
            if (this.deviceService.isMobile()) {
                url = AppSettings.iPhonePhone;
            }
            if (this.deviceService.isTablet()) {
                url = AppSettings.iPhoneTab;
            }
        }
        if (url == "") {
            const modalData: any = {};
            modalData.Title = this.translate.instant("Common_lblInfo");
            modalData.Message = this.translate.instant("Message_msgAppDownloadLink");
            // this.modal.overlay.defaultViewContainer = this.vcRef;
            this.modal.open(
                ErrorPopupComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
            );
            return false;
        }
        window.open(url, "_blank");
    }
    getBackGroundImageEnvelope() {
        this.userGioLocation = new UserGioLocation();
        this.geoloc.getserGioLocation().subscribe(data => {
            this.userGioLocation = data;
        });
        const envelope = `{
                        "Latitude":"${this.userGioLocation.longitude}",
                        "Longitude":"${this.userGioLocation.latitude}",
                        "ImageType":"loginbackground",
                        "DeviceType":"web",
                        "UpdatedTimeStamp": ""
                        }`;
        return envelope;
    }

    register() {
        this.loyallog.setEditUserData(null);
        this.router.navigate(["/register"]);
    }
}



// WEBPACK FOOTER //
// ./src/app/user/login/login.component.ts